import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    editEmailSetting,
    editUserSetting,
    getUserSetting,
    Logout,
    onErrorAlert,
    onSuccessAlert
} from "../../../actions";
import MDBox from "../../../components/MDBox";
import {FormControl, FormHelperText, InputAdornment, Paper} from "@mui/material";
import MDInput from "../../../components/MDInput";
import IconButton from "@mui/material/IconButton";
import MDButton from "../../../components/MDButton";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import PlacesAutocomplete, {geocodeByAddress} from "react-places-autocomplete";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {noop} from "lodash";
import LocalStorage from "../../../utils/LocalStorage";
import api from "../../../api/api";
import {File_Upload} from "../../../config";
import MDAvatar from "../../../components/MDAvatar";
import burceMars from "../../../assets/images/logos/darwynn/DarwynnAvatar.svg";
import axios from "axios";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {useTranslation} from "react-i18next";



const schema = yup
    .object({
        // lastname: yup.string().matches(/^\S*$/, 'No spaces allowed in last name').required('Last name is Required').min(1, 'Please Input Valid Name'),
        // firstname: yup.string().matches(/^\S*$/, 'No spaces allowed in first name').required('First name is Required').min(1, 'Please Input Valid Name'),
        // address1: yup.string().trim(),
        // address2: yup.string().trim(),
    })
const UserInformation = ({setOpen}) => {
    const {t} = useTranslation();
    const [file, setFile] = useState(null);
    const [uploadFile, setUploadFile] = useState(null);
    function handleImgChange(e) {
        setUploadFile(e.target.files[0]);
        setFile(URL.createObjectURL(e.target.files[0]));
    }


    const {
        register,
        trigger,
        reset,
        setError,
        handleSubmit,
        getValues,
        setValue,
        clearErrors,
        formState: {errors}
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next)
    const userInfo = useSelector(state => state?.auth?.userSetting,(prev, next) => prev === next);
    const [userInfoData, setUserInfoData] = useState({});

    const getIdIndex = (type, arr) => {
        let res = 0
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === type) {
                res = i
            }
        }
        return res
    }

    const activeFlagTypeList = [
        {
            id: 0,
            value: '0',
            title: 'Create  Status'
        },
        {
            id: 1,
            value: '1',
            title: 'Open  Status'
        },
        {
            id: 2,
            value: '2',
            title: 'Close  Status'
        }
    ]
    const [activeFlagType, setActiveFlagType] = useState(activeFlagTypeList[getIdIndex(userInfoData?.activeFlag, activeFlagTypeList)])


    const ownerTypeList = [
        {
            id: 1,
            value: 'INDIVIDUAL',
            title: 'B2C Owner(include B2B)',
        },
        {
            id: 2,
            value: 'ENTERPRISE',
            title: 'B2B Owner',
        }]
    const [ownerType, setOwnerType] = useState(ownerTypeList[getIdIndex(userInfoData?.accountType, ownerTypeList)])

    function handleOwnerType(event, v) {
        setOwnerType(v)
    }

    function handleActiveFlagType(event, v) {
        setActiveFlagType(v)
    }


    const ID_TYPES = {
        PASSPORT: 'PASSPORT',
        DRIVING_LICENCE: 'DRIVING_LICENSE',
        CITIZEN_CARD: 'CITIZEN_CARD',
        RESIDENT_CARD: 'RESIDENT_ID_CARD'
    }
    const IDTYPE_ARRAY = [
        {id: 1, value: ID_TYPES.PASSPORT, title: 'Passport'},
        {id: 2, value: ID_TYPES.DRIVING_LICENCE, title: `Driver’s License`},
        {id: 3, value: ID_TYPES.CITIZEN_CARD, title: 'Citizen Card'},
        {id: 4, value: ID_TYPES.RESIDENT_CARD, title: 'Resident Card'},
    ]

    const [idType, setIdType] = useState(IDTYPE_ARRAY[getIdIndex(userInfoData?.idType, IDTYPE_ARRAY)])


    function handleIdType(event, v) {
        setIdType(v)
    }


    const [address, setAddress] = useState("")
    const [cityValue, setCityValue] = useState("")
    const [provinceValue, setProvinceValue] = useState("")
    const [postcodeValue, setPostcodeValue] = useState("")
    const [countryValue, setCountryValue] = useState("")
    const addressFilter = ['address']
    const [hoverSelect, setHoverSelect] = useState(false)
    const handleMouseEnter = (index) => {
        setHoverSelect(index);
    };

    const handleMouseLeave = () => {
        setHoverSelect(-1);
    };
    const handleSelect = async address => {
        const results = await geocodeByAddress(address)
        let address1 = "";
        let postcode = "";
        let city = '';
        let state = '';
        let country = '';
        for (const component of results[0].address_components) {
            const componentType = component.types[0];

            switch (componentType) {
                case "street_number": {
                    address1 = `${component.long_name} ${address1}`;
                    break;
                }

                case "route": {
                    address1 += component.short_name;
                    break;
                }

                case "postal_code": {
                    postcode = `${component.long_name}${postcode}`;
                    break;
                }

                case "postal_code_suffix": {
                    postcode = `${postcode}-${component.long_name}`;
                    break;
                }

                case "locality":
                    city =
                        component.long_name;
                    break;

                case "administrative_area_level_1": {
                    state =
                        component.short_name;
                    break;
                }

                case "country":
                    country =
                        component.short_name.toLowerCase();
                    break;
            }
        }
        setAddress(address1)
        setCityValue(city)
        setProvinceValue(state)
        setCountryValue(country)
        setPostcodeValue(postcode)
    };


    const dispatch = useDispatch();


    useEffect(() => {
        setFile(userInfo?.logoImage)
        setValue('ownerId', userInfo?.ownerId)
        setValue('omsOwnerId', userInfo?.omsOwnerId)
        setValue('userName', userInfo?.userName)
        // setValue('firstName', userInfo?.firstName)
        // setValue('lastName', userInfo?.lastName)
        setValue('phone', userInfo?.phone)
        setValue('companyName', userInfo?.companyName)
        setValue('companySite', userInfo?.companySite)
        setValue('idType', userInfo?.idType)
        setValue('idNumber', userInfo?.idNumber)
        setValue('address2', userInfo?.address2)
        setAddress(userInfo?.address1)
        setCityValue(userInfo?.city)
        setProvinceValue(userInfo?.province)
        setCountryValue(userInfo?.country)
        setPostcodeValue(userInfo?.postcode)

        getAvatarUrl()
    }, [userInfo])





    const onSubmit = (xdata) => {
        const formData = new FormData()
        if(!!uploadFile){
            if(uploadFile.size > 500000){
                onError('File size exceeds 500 KB. Please choose a smaller file.')
            }
            formData.append("file", uploadFile)
            if (!checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
                formData.append("userName", LocalStorage.getItem('username'));
            }
            let fileUrl = ""
            const axiosPost = async () => {
                if (!(checkPermission(PERMISSION_DICT.AccountPictureUpload) && checkPermission(PERMISSION_DICT.AccountProfileModify))) return null;
                const res = await api.post(File_Upload, formData).then(res => res)
                if (res?.status === 200 && res.data.code === 200) {
                    fileUrl = res.data.data.url

                }
            }
            axiosPost().then(
                ()=>{
                    let userInfoCopy = {...userInfo}
                    userInfoCopy.phone = getValues('phone')
                    // userInfoCopy.lastName = getValues('lastName')
                    // userInfoCopy.firstName = getValues('firstName')
                    userInfoCopy.companySite = getValues('companySite')
                    userInfoCopy.companyName = getValues('companyName')
                    userInfoCopy.address2 = getValues('address2')
                    userInfoCopy.userName = localStorage.getItem("username")
                    userInfoCopy.address1 = address
                    userInfoCopy.city = cityValue
                    userInfoCopy.province = provinceValue
                    userInfoCopy.country = countryValue
                    userInfoCopy.postcode = postcodeValue
                    userInfoCopy.logoImage = fileUrl
                    const formDataInfo = {
                        userInfo: userInfoCopy
                    }
                    const axiosPost = async () => {
                        await dispatch(editUserSetting(formDataInfo,onEditSuccess,onError))
                    }
                    axiosPost().then()
                }

            )
        }else {
            let userInfoCopy = {...userInfo}
            userInfoCopy.phone = getValues('phone')
            // userInfoCopy.lastName = getValues('lastName')
            // userInfoCopy.firstName = getValues('firstName')
            userInfoCopy.companySite = getValues('companySite')
            userInfoCopy.companyName = getValues('companyName')
            userInfoCopy.address2 = getValues('address2')
            userInfoCopy.userName = localStorage.getItem("username")
            userInfoCopy.address1 = address
            userInfoCopy.city = cityValue
            userInfoCopy.province = provinceValue
            userInfoCopy.country = countryValue
            userInfoCopy.postcode = postcodeValue
            const formDataInfo = {
                userInfo: userInfoCopy
            }
            const axiosPost = async () => {
                await dispatch(editUserSetting(formDataInfo,onEditSuccess,onError))
            }
            axiosPost().then()
        }
    }



    const onEditSuccess = async (msg) => {
        dispatch(onSuccessAlert(t(msg)))
        await dispatch(getUserSetting())
        setOpen(false)
    }


    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    function isUrl(url) {
        const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
        return urlRegex.test(url);
    }
    const getAvatarUrl = async () => {
        if (!!userInfo?.logoImage && isUrl(userInfo?.logoImage)) {
            await axios.get(userInfo?.logoImage).then(res => {
                if (res.status === 200) {
                    setFile(userInfo?.logoImage)
                } else {
                    setFile(burceMars)
                }
            }).catch(err => {
                setFile(burceMars)
            })
        }else {
            setFile(burceMars)
        }
    }


    return (
        <div>
            <div>
                <MDBox pt={2} pb={2} px={3}>
                    <MDBox component="form" role="form"  onSubmit={handleSubmit(onSubmit)}>
                        <label htmlFor="contained-button-file">
                            <IconButton>
                                <MDAvatar src={file} alt="profile-image" size="xl" shadow="sm"/>
                            </IconButton>
                        </label>

                        <Button
                            disabled={!checkPermission(PERMISSION_DICT.AccountPictureUpload)}
                            size="small"
                            component="label"
                            role={undefined}
                            variant="gradient"
                            tabIndex={-1}
                            color="info"
                            startIcon={<CloudUploadIcon/>}
                        >
                            <input
                                accept="image/*"
                                type="file"
                                hidden
                                onChange={handleImgChange}
                            />
                            {t("AccountPage.Upload file")}
                        </Button>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12} lg={6}>
                                <Paper elevation={0} sx={{padding: "10px", marginBottom: "20px"}}>
                                    <Typography variant="h6">
                                        {t("AccountPage.Personal Information")}
                                    </Typography>
                                    <Grid item container xs={12} spacing={1}>
                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <FormControl
                                                    fullWidth
                                                    required
                                                    focused={true}
                                                >
                                                    <MDInput
                                                        type={'text'}
                                                        label={t("AccountPage.Owner ID")}
                                                        variant="standard"
                                                        fullWidth
                                                        disabled={true}
                                                        required
                                                        {...register("ownerId")}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </FormControl>
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <FormControl
                                                    fullWidth
                                                    required
                                                    focused={true}
                                                >
                                                    <MDInput
                                                        type={'text'}
                                                        label={t("AccountPage.Original Owner ID")}
                                                        variant="standard"
                                                        fullWidth
                                                        required
                                                        disabled={true}
                                                        {...register("omsOwnerId")}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.password?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <FormControl
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        disabled={true}
                                                        // disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                                        type={'text'}
                                                        label={t("AccountPage.User Name")}
                                                        variant="standard"
                                                        fullWidth
                                                        required
                                                        {...register("userName")}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.userName?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>

                                        {/*<Grid item xs={6} mt={1}>*/}
                                        {/*    <MDBox>*/}
                                        {/*        <FormControl*/}
                                        {/*            fullWidth*/}
                                        {/*            required*/}
                                        {/*        >*/}
                                        {/*            <MDInput*/}
                                        {/*                disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}*/}
                                        {/*                // disabled={true}*/}
                                        {/*                type={'text'}*/}
                                        {/*                label="Last Name"*/}
                                        {/*                variant="standard"*/}
                                        {/*                fullWidth*/}
                                        {/*                required*/}
                                        {/*                {...register("lastName")}*/}
                                        {/*                InputLabelProps={{*/}
                                        {/*                    shrink: true,*/}
                                        {/*                }}*/}
                                        {/*            />*/}
                                        {/*            <FormHelperText*/}
                                        {/*                sx={{fontWeight: 'medium'}}>{errors?.confirmPassword?.message}</FormHelperText>*/}
                                        {/*        </FormControl>*/}
                                        {/*    </MDBox>*/}
                                        {/*</Grid>*/}

                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <FormControl
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        // disabled={true}
                                                        disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                                        type={'text'}
                                                        label={t("AccountPage.Phone")}
                                                        variant="standard"
                                                        fullWidth
                                                        required
                                                        {...register("phone")}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.confirmPassword?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>


                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={12} lg={6}>
                                <Paper elevation={0} sx={{padding: "10px", marginBottom: "20px"}}>
                                    <Typography variant="h6">
                                        {t("AccountPage.Company Information")}
                                    </Typography>
                                    <Grid item container xs={12} spacing={1}>
                                        {/*<Grid item xs={6} mt={1}>*/}
                                        {/*    <MDBox>*/}
                                        {/*        <FormControl*/}
                                        {/*            fullWidth*/}
                                        {/*            required*/}
                                        {/*        >*/}
                                        {/*            <Autocomplete*/}
                                        {/*                disableClearable*/}
                                        {/*                // disabled={true}*/}
                                        {/*                sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}*/}
                                        {/*                options={ownerTypeList}*/}
                                        {/*                getOptionLabel={(option) => option.title}*/}
                                        {/*                isOptionEqualToValue={(option, value) => option?.id === value?.id}*/}
                                        {/*                value={ownerType}*/}
                                        {/*                onChange={handleOwnerType}*/}
                                        {/*                renderInput={(params) => (*/}
                                        {/*                    <MDInput*/}
                                        {/*                        {...params}*/}
                                        {/*                        variant="standard"*/}
                                        {/*                        label="Owner Type"*/}
                                        {/*                        required={true}*/}
                                        {/*                    />*/}
                                        {/*                )}*/}
                                        {/*            />*/}
                                        {/*            <FormHelperText*/}
                                        {/*                sx={{fontWeight: 'medium'}}>{errors?.idType?.message}</FormHelperText>*/}
                                        {/*        </FormControl>*/}
                                        {/*    </MDBox>*/}
                                        {/*</Grid>*/}


                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <FormControl
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                                        type={'text'}
                                                        label={t("AccountPage.Company Name")}
                                                        // disabled={true}
                                                        variant="standard"
                                                        fullWidth
                                                        required
                                                        {...register("companyName")}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.companyName?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <FormControl
                                                    error={!!errors.companySite}
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                                        type={'text'}
                                                        label={t("AccountPage.Company Site")}
                                                        variant="standard"
                                                        fullWidth
                                                        {...register("companySite")}
                                                        // disabled={true}
                                                        // value={''}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.companySite?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <FormControl
                                                    error={!!errors.idType}
                                                    fullWidth
                                                    required
                                                ><Autocomplete
                                                    disableClearable
                                                    sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}
                                                    options={IDTYPE_ARRAY}
                                                    getOptionLabel={(option) => option.title}
                                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                    value={idType}
                                                    disabled={true}
                                                    onChange={handleIdType}
                                                    renderInput={(params) => (
                                                        <MDInput
                                                            {...params}
                                                            variant="standard"
                                                            label={t("AccountPage.ID Type")}
                                                            required={true}
                                                        />
                                                    )}
                                                />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.idType?.message}</FormHelperText>

                                                </FormControl>
                                            </MDBox>
                                        </Grid>

                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <FormControl
                                                    error={!!errors.idNumber}
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        type={'text'}
                                                        label={t("AccountPage.ID Number")}
                                                        variant="standard"
                                                        fullWidth
                                                        required
                                                        disabled={true}
                                                        {...register("idNumber")}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.idNumber?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper elevation={0} sx={{padding: "10px", marginBottom: "40px"}}>
                                    <Typography variant="h6">
                                        {t("AccountPage.Address Information")}
                                    </Typography>
                                    <Grid item container xs={12} columnSpacing={4} rowSpacing={2}>
                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <PlacesAutocomplete
                                                    value={address}
                                                    onChange={setAddress}
                                                    onSelect={handleSelect}
                                                    searchOptions={{
                                                        language: languageSelect === 'zh' ? 'zh' : 'en',
                                                        types: addressFilter,
                                                        fields: ["address_components"],
                                                        componentRestrictions: {
                                                            country: ['us', 'ca', 'cn'],
                                                        },
                                                    }}
                                                    debounce={200}
                                                >
                                                    {({
                                                          getInputProps,
                                                          suggestions,
                                                          getSuggestionItemProps,
                                                          loading
                                                      }) => (
                                                        <FormControl
                                                            error={!!errors.address1}
                                                            fullWidth
                                                            required
                                                            focused={true}
                                                        >
                                                            <MDInput
                                                                {...getInputProps()}
                                                                // disabled={true}
                                                                disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                                                type="text"
                                                                label={t("AccountPage.Address 1")}
                                                                inputProps={{
                                                                    autocomplete: "new-password",
                                                                }}
                                                                variant="standard"
                                                                fullWidth
                                                                required
                                                                defaultValue={userInfoData?.address1}
                                                                value={address}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />
                                                            <FormHelperText
                                                                sx={{fontWeight: 'medium'}}>{errors?.address1?.message}</FormHelperText>
                                                            <div>
                                                                {loading &&
                                                                    <div style={{fontSize: 'small'}}>Loading...</div>}
                                                                {suggestions.map((suggestion, index) => (
                                                                    <div {...getSuggestionItemProps(suggestion)}>
                                                            <span
                                                                onMouseEnter={() => handleMouseEnter(index)}
                                                                onMouseLeave={handleMouseLeave}
                                                                style={{
                                                                    fontSize: 'small',
                                                                    cursor: 'pointer',
                                                                    fontStyle: index === hoverSelect ? 'italic' : 'normal'
                                                                }}
                                                            >{suggestion.description}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </FormControl>

                                                    )

                                                    }

                                                </PlacesAutocomplete>

                                            </MDBox>
                                        </Grid>

                                        <Grid item xs={6} mt={1}>
                                            <MDBox>
                                                <FormControl
                                                    error={!!errors.address2}
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        // disabled={true}
                                                        disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                                        type={'text'}
                                                        label={t("AccountPage.Address 2")}
                                                        inputProps={{
                                                            autocomplete: "new-password",
                                                        }}
                                                        variant="standard"
                                                        fullWidth
                                                        {...register("address2")}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.address2?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>


                                        <Grid item xs={6}>
                                            <MDBox>
                                                <FormControl
                                                    error={!!errors.city}
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        // disabled={true}
                                                        disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                                        type={'text'}
                                                        label={t("AccountPage.City")}
                                                        inputProps={{
                                                            autocomplete: "new-password",
                                                        }}
                                                        variant="standard"
                                                        fullWidth
                                                        required
                                                        onChange={(e)=>setCityValue(e.target.value)}
                                                        value={cityValue}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.city?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>


                                        <Grid item xs={6}>
                                            <MDBox>
                                                <FormControl
                                                    error={!!errors.province}
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        // disabled={true}
                                                        disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                                        type={'text'}
                                                        label={t("AccountPage.State/Province")}
                                                        variant="standard"
                                                        inputProps={{
                                                            autocomplete: "new-password",
                                                        }}
                                                        fullWidth
                                                        required
                                                        onChange={(e)=>setProvinceValue(e.target.value)}
                                                        value={provinceValue}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.province?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <MDBox>
                                                <FormControl
                                                    error={!!errors.country}
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        disabled={true}
                                                        type={'text'}
                                                        label={t("AccountPage.Country")}
                                                        inputProps={{
                                                            autocomplete: "new-password",
                                                        }}
                                                        variant="standard"
                                                        fullWidth
                                                        required
                                                        value={countryValue}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.country?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>

                                        {/*<Grid item xs={6}>*/}
                                        {/*    <MDBox>*/}
                                        {/*        <FormControl*/}
                                        {/*            error={!!errors.activeFlag}*/}
                                        {/*            fullWidth*/}
                                        {/*            required*/}
                                        {/*        >*/}
                                        {/*            <Autocomplete*/}
                                        {/*                // disabled={true}*/}
                                        {/*                sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}*/}
                                        {/*                disableClearable*/}
                                        {/*                options={activeFlagTypeList}*/}
                                        {/*                getOptionLabel={(option) => option.title}*/}
                                        {/*                isOptionEqualToValue={(option, value) => option?.id === value?.id}*/}
                                        {/*                value={activeFlagType}*/}
                                        {/*                onChange={handleActiveFlagType}*/}
                                        {/*                renderInput={(params) => (*/}
                                        {/*                    <MDInput*/}
                                        {/*                        {...params}*/}
                                        {/*                        variant="standard"*/}
                                        {/*                        label="Active Flag"*/}
                                        {/*                        required={true}*/}
                                        {/*                    />*/}
                                        {/*                )}*/}
                                        {/*            />*/}
                                        {/*            <FormHelperText*/}
                                        {/*                sx={{fontWeight: 'medium'}}>{errors?.activeFlag?.message}</FormHelperText>*/}
                                        {/*        </FormControl>*/}
                                        {/*    </MDBox>*/}
                                        {/*</Grid>*/}

                                        <Grid item xs={6}>
                                            <MDBox>
                                                <FormControl
                                                    error={!!errors.postcode}
                                                    fullWidth
                                                    required
                                                >
                                                    <MDInput
                                                        // disabled={true}
                                                        disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                                        type={'text'}
                                                        label={t("AccountPage.Postal Code")}
                                                        variant="standard"
                                                        inputProps={{
                                                            autocomplete: "new-password",
                                                        }}
                                                        fullWidth
                                                        required
                                                        onChange={(e)=>setPostcodeValue(e.target.value)}
                                                        value={postcodeValue}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    <FormHelperText
                                                        sx={{fontWeight: 'medium'}}>{errors?.postcode?.message}</FormHelperText>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>


                                        {/*<Grid item xs={12} mt={2}>*/}
                                        {/*    <MDBox mt={2}>*/}
                                        {/*        <MDButton variant="gradient" color="info">*/}
                                        {/*            submit*/}
                                        {/*        </MDButton>*/}
                                        {/*    </MDBox>*/}
                                        {/*</Grid>*/}
                                    </Grid>
                                </Paper>
                            </Grid>

                        </Grid>

                        <MDBox style={{display: "flex",flexDirection: "row-reverse"}}>
                            <MDButton variant="contained" color="primary"
                                      // disabled
                                      disabled={!checkPermission(PERMISSION_DICT.AccountProfileModify)}
                                      type={'submit'}
                                      sx={{marginRight:"10px"}}
                                // onClick={onSubmit}
                            >
                                {t("Submit")}
                            </MDButton>

                            <MDButton variant="outlined" color="primary"
                                      sx={{marginRight:"10px"}}
                                 onClick={()=>{
                                     setOpen(false)
                                 }}
                            >
                                {t("Cancel")}
                            </MDButton>


                        </MDBox>
                    </MDBox>
                </MDBox>
            </div>
        </div>
    )
}
export default UserInformation